export default "__VITE_ASSET__BrYyfhL9__"